export default "__VITE_ASSET__7efa8257__"